import React from "react";
import { Link } from "react-router-dom";
import { APP_URLS } from "../constants";

const Service = (props) => {


    return (
        <div className="service-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="icon-outer">
                    <div className="icon-box">
                        <span className="icon"><img src="images/icons/service-icon-1.png" alt="" /></span>
                    </div>
                </div>
                <h3>{props.values.title}</h3>
                <div className="text">{props.values.desc1}</div>

                <div className="overlay-box">
                    <div className="overlay-inner">
                        <div className="content">
                            <h4><Link to={ APP_URLS.SERVICE_DETAIL+'?service='+props.values.path}>{props.values.title}</Link></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Service
